import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {Constants} from '../../constants/constants';

@Component({
  selector: 'app-timezone',
  imports: [TranslatePipe],
  templateUrl: './timezone.component.html',
  styleUrl: './timezone.component.scss',
})
export class TimezoneComponent {

  protected currentTimezone: string = this.initCurrentTimezone();

  private initCurrentTimezone(): string {
    const offset = new Date().getTimezoneOffset();
    const sign = offset <= 0 ? Constants.PLUS: Constants.HYPHEN;
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, Constants.ZERO);
    const minutes = String(Math.abs(offset) % 60).padStart(2, Constants.ZERO);
    return `${Constants.UTC}${sign}${hours}${Constants.COLON}${minutes}`;
  }

}
